import React from 'react'
import CategoryListTable from './Components/CategoryListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const CategoryList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Product Category List</HeadingOne>
          <AddItemBtn url="add-category" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <CategoryListTable />
      </div>
    </PageBody>
  );
};

export default CategoryList;
